import {User} from 'src/app/app-shared-elements/_interfaces/user.interface';

export class InitMobileNavSettings {
    static readonly type = '[MobileNav] InitMobileNavSettings';
    constructor(public user: User) {

    }
}

